/**
 * Set Dire
 * @param {Object} payload - Dire Object to set.
 */
export const set = ({ commit }, payload) => {
  if (!payload) {
    empty({ commit })
  } else {
    return new Promise((resolve, reject) => {
      if (payload.publicSectorInformation) {
        commit('SET_PUBLIC_CODE', payload.publicSectorInformation.publicOrganismCode)
        commit('SET_CONTRACT_REFERENCE', payload.publicSectorInformation.contractReference)
      }
      if (payload.buyerCentres.receiverAdministrativeCentre) {
        commit('SET_RECEIVER_CODE', payload.buyerCentres.receiverAdministrativeCentre.code)
        commit('SET_RECEIVER_NAME', payload.buyerCentres.receiverAdministrativeCentre.name)
      }
      resolve()
    })
  }
}

export const empty = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_PUBLIC_CODE', undefined)
    commit('SET_CONTRACT_REFERENCE', undefined)
    commit('SET_RECEIVER_CODE', undefined)
    commit('SET_RECEIVER_NAME', undefined)
    resolve()
  })
}
